import dayjs, { Dayjs } from 'dayjs';

/** Indian financial years run 1 April to 31 March. */
export const FY_START_MONTH = 4;

/**
 * The financial year a date falls in, labelled the way `financial_years.label` is seeded:
 * 2027-02-02 → "2026-2027", 2026-02-02 → "2025-2026", 2026-04-01 → "2026-2027".
 *
 * Returns null for an absent or unparseable date rather than a year built from NaN.
 */
export function financialYearLabel(date: string | Date | Dayjs | null | undefined): string | null {
  if (!date) return null;

  const parsed = dayjs(date as any);
  if (!parsed.isValid()) return null;

  // dayjs months are 0-based, so April is 3.
  const startYear = parsed.month() >= FY_START_MONTH - 1 ? parsed.year() : parsed.year() - 1;
  return `${startYear}-${startYear + 1}`;
}
